<template>
	<a
		class="user-pill"
		:href="link"
		:target="newTab ? '_blank' : ''"
		:class="{ 'with-badge': badge }"
		tabindex="-1"
	>
		<ProfilePic :user="profile" size="40px" class="photo" />
		<div class="user-pill-info">
			<div class="main-text" :title="mainText">
				{{ mainText }}
			</div>
			<div class="sub-text" :title="subText" v-if="subText">
				{{ subText }}
			</div>
			<slot />
		</div>
		<div class="badge">{{ badge }}</div>
	</a>
</template>

<script>
import { ProfilePic } from '../common'

export default {
	name: 'BasicUserPill',
	props: ['profile', 'mainText', 'subText', 'link', 'newTab', 'badge'],
	components: { ProfilePic },
}
</script>

<style lang="scss" scoped>
.user-pill {
	display: flex;
	align-items: center;
	// background: white;
	border-radius: 5px;
	text-decoration: none;
	color: inherit;
	min-width: calc(100% - 100px);
	.photo {
		flex-shrink: 0;
	}
	.badge {
		display: none;
		color: white;
		background: red;
		padding: 4px 8px;
		border-radius: 16px;
		font-size: 12px;
		font-family: Avenir-Heavy;
	}
	.user-pill-info {
		max-width: calc(100% - 50px);
	}
	&.with-badge {
		.user-pill-info {
			max-width: calc(100% - 70px);
		}
		.badge {
			display: block;
		}
	}
}
.user-pill-info {
	width: 100%;
	flex: 1;
	margin: 0 8px;
	cursor: pointer;
	.main-text {
		font-size: 14px;
		font-family: Avenir-Heavy;
	}
	.sub-text {
		font-size: 12px;
		font-family: Avenir-Book;
	}
	.main-text,
	.sub-text {
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
